import {
  delayOffset,
  intersectionWatcher,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  sectionBlockItems: ".animation--section-introduction > *",
  items: ".collapsible-row-list-item",
};

export default node => {
  if (!shouldAnimate(node)) return;
  // Add the animation delay offset variables
  delayOffset(node, [selectors.sectionBlockItems, selectors.items]);

  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
